<template>
    <div class="container-fluid" > <!-- style="background-color: #4cae4c;" -->
        <!-- 通过枚举, 列出所有活动 item -->
        <div class="row activities">
            <div class="col-xs-12" v-for="item in list">
                <a :href="item.target" target="_self">
                    <div class="activity">
                        <div class="image-wrap">
                            <img :src="item.imageUrl"/>
                        </div>
                        <div class="text-wrap">
                            <p>{{item.description}}</p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div v-show="isEmptyList"><p>{{emptyListTip}}</p></div>
    </div>
</template>

<script>
    export default {
        name: 'activities',
        data () {
            return {
                emptyListTip: '',
                isEmptyList: true,
                list: []
            }
        },
        mounted () {
            this.nvOnLoad(this.onCreate)
            // 加载活动数据
            this.loadActivities()
        },
        methods: {
            onCreate (context) {
                context.emptyListTip = context.nvStrings['activities_empty_list']
            },
            loadActivities () {
                var context = this
                // 从本地文件中读取活动列表
                this.nvGetDefaultJson('activities.json', response => {
                    // 数据更新时 UI 也会更新, 在这里可以手动设置一些测试数据来看浏览器页面的变化
                    context.list = response.data['activities']
                    // or that.list = response.data.activities
                    context.isEmptyList = context.list.length < 1
                }, exception => {
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
    @import '../../style/common'
    .activities
        padding-top: 20px
        .col-xs-12
            padding-left: 12px
            padding-right: 12px
        a
            text-decoration: none
            color: black
        .activity
            width: 100%
            border: 1px solid #c4c4c4
            margin-bottom: 20px
            .image-wrap
                width: 100%
                img
                    width: 100%
                    height: auto
            .text-wrap
                width: 100%
                p
                    font-family: lato-regular
                    margin: 12px 12px
                    text-align: left
                    font-size: 16px

</style>



// WEBPACK FOOTER //
// Activities.vue?29738e29